import { isAssignmentLocked } from "./marksConstants";

export const formatDate = (d) => {
  if (!d) return "";
  return new Date(d).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const toId = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  return v._id || v.id || "";
};

export const pickList = (res, keys = ["data", "eligible", "assignments", "teachers", "entries", "schemes", "rows"]) => {
  if (Array.isArray(res)) return res;
  if (!res || typeof res !== "object") return [];
  for (const k of keys) {
    if (Array.isArray(res[k])) return res[k];
  }
  return [];
};

/** Build save payload rows from entry table state */
export const buildMarksSavePayload = (assignmentId, rows) => ({
  assignmentId,
  entries: (rows || []).map((r) => ({
    studentId: toId(r.student) || r.studentId,
    marksObtained: r.isAbsent ? 0 : r.marksObtained,
    isAbsent: Boolean(r.isAbsent),
  })),
});

export const canEditMarks = (assignment) =>
  assignment && !isAssignmentLocked(assignment.status);

export const teacherLabel = (t) => {
  const staff = t?.staff || t;
  if (!staff) return "";
  return staff.name
    ? `${staff.name}${staff.staffCode ? ` (${staff.staffCode})` : ""}`
    : staff.staffCode || toId(staff);
};
